import * as React from 'react';
import { CompositionState, SetCompositionState } from './Composition';

export function useCompositionSetters(setComposition: SetCompositionState) {

	const setAddinsSelection = React.useCallback((values: Partial<CompositionState['addinsSelection']>) => {
		setComposition(prev => ({ ...prev, addinsSelection: { ...prev.addinsSelection, ...values } }));
	}, [setComposition]);

	const setLotSelection = React.useCallback((values: Partial<CompositionState['lotSelection']>) => {
		setComposition(prev => ({ ...prev, lotSelection: { ...prev.lotSelection, ...values } }));
	}, [setComposition]);

	const setPreparationNotes = React.useCallback((preparationNotes: string) => {
		setComposition(prev => ({...prev, preparationNotes }));
	}, [setComposition]);

	const setSize = React.useCallback((size: CompositionState['size']) => {
		setComposition(prev => ({...prev, size }));
	}, [setComposition]);

	const setColor = React.useCallback((color: CompositionState['color']) => {
		setComposition(prev => ({...prev, color }));
	}, [setComposition]);

	const setRemovedIngredients = React.useCallback((removedIngredients: CompositionState['removedIngredients']) => {
		setComposition(prev => ({...prev, removedIngredients }));
	}, [setComposition]);

	return {
		setAddinsSelection,
		setLotSelection,
		setPreparationNotes,
		setSize,
		setColor,
		setRemovedIngredients
	};
}
